import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
} from "@angular/core";
import { Location } from "@angular/common";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup,
  UntypedFormArray,
  FormGroup,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { ViewChild } from "@angular/core";
import { Blog } from "../../../models/blog";
import { Category } from "../../../models/category";
import { UntypedFormControl } from "@angular/forms";
import { ConfirmationService, MessageService, SelectItem } from "primeng/api";
import {
  TYPE_LIST,
  STATE_LIST,
  STATE_PUBLISHED,
  FEATURED_OPTIONS,
  COUNTRIES,
  NOTES_LIST,
} from "../../constants/constants";
import { CommonModule, DOCUMENT } from "@angular/common";
import { Works } from "src/app/models/works";
import { Locations } from "src/app/models/locations";
import { Technical_data } from "src/app/models/technical_data";
import { Observable } from "rxjs";
import { SlideshowService } from "src/app/services/slideshow.service";
import { Slideshow } from "src/app/models/slideshow";
import { NgxSpinnerService } from "ngx-spinner";
import { StartupsService } from "src/app/services/startups.service";
import { Startups } from "src/app/models/startups";
import { FoundersService } from "src/app/services/founders.service";
import { CategoryService } from "src/app/services/categories.service";
import { UsersService } from "src/app/services/users.service";
import { Users } from "src/app/models/users";
import { environment } from "src/environments/environment";
import { EmailService } from "src/app/services/email.service";
import { TechnologyService } from "src/app/services/technology.service";
import { EditorModule } from "primeng/editor";
import { SelectModule } from "primeng/select";
import { MultiSelectModule } from "primeng/multiselect";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { TabsModule } from "primeng/tabs";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { CheckboxModule } from "primeng/checkbox";
import { AutoCompleteModule } from "primeng/autocomplete";
import { TextareaModule } from "primeng/textarea";
import { ImageModule } from "primeng/image";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TooltipModule } from "primeng/tooltip";
import { TagModule } from "primeng/tag";
import { SlugTransformDirective } from "../../pipe/slug-transform.directive";
import { UploadComponent } from "../../components/upload/upload.component";
import { UploadSingleComponent } from "../../components/upload-single/upload-single.component";
import { PointsSelectorComponent } from "../../components/points-selector/points-selector.component";

export interface fPairs {
  label: number;
  value: number;
}

import { TopNavComponent } from "src/app/top-nav/top-nav.component";

import { DatePickerModule } from "primeng/datepicker";

@Component({
  standalone: true,
  selector: "app-startups-form",
  templateUrl: "./startups-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    EditorModule,
    SelectModule,
    MultiSelectModule,
    ToggleSwitchModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    TabsModule,
    InputGroupModule,
    InputGroupAddonModule,
    CheckboxModule,
    AutoCompleteModule,
    TextareaModule,
    ImageModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule,
    TagModule,
    UploadComponent,
    UploadSingleComponent,
    PointsSelectorComponent,
    TopNavComponent,
    DatePickerModule,
  ],
})
export class StartupsFormComponent implements OnInit {
  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;
  pageTitle: string;
  error: string;
  uploadError: string;
  imagePath: any;
  id: number;
  selectedCountry: SelectItem[];
  selectedNotes: SelectItem[];
  selectedFeatured: SelectItem[];

  category: Category;
  works: any = [];
  work: Works;
  requestResponse: any;

  blogForm: FormGroup;
  user: Users;
  typeList: any[];
  statePublished: any[];
  stateOptions: any[];
  selectedStatePublished: SelectItem[] = [];
  count = 0;
  imageInfos?: Observable<any>;
  selectedDate: Date;
  date: Date;
  basePath: string;
  category_id: any;
  currentUser: any;
  elementsUrl: Startups[] = [];
  hasDuplicates = false;
  technologyList: any = [];
  startups: Startups[];
  rows: UntypedFormArray;
  skillsValues: any = [];
  trackByFn(index, item) {
    return item.id;
  }
  element: Startups;
  selectedTechnology: SelectItem[] = [];
  visibleDates: boolean;
  page = 1;
  pageSize = 10;
  tourTitle: string;
  startupStatus: any;
  categoriesList: Category[] = [];
  notesList: any;
  selectedCategories: SelectItem[] = [];
  featuredOptions: any[];
  userIdentification: number;
  countriesList: any[];
  startupUrl: string;
  path = environment.logo_url;
  founders: any[] = [];
  foundersLoading = false;
  isSaving = false;
  loadingPage = false;
  domainRating: {
    loading: boolean;
    rating?: number;
    domain?: string;
    source?: string;
    error?: boolean;
  };
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private startupsService: StartupsService,
    private foundersService: FoundersService,
    private emailService: EmailService,
    private usersService: UsersService,
    private spinner: NgxSpinnerService,
    private categoryService: CategoryService,
    private technologyService: TechnologyService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private slideshowService: SlideshowService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private location: Location,
  ) {
    this.basePath = window.location.pathname;
    if (this.route.snapshot.queryParamMap.has("page")) {
      this.page = +this.route.snapshot.queryParamMap.getAll("page");
    }
    if (this.route.snapshot.queryParamMap.has("size")) {
      this.pageSize = +this.route.snapshot.queryParamMap.getAll("size");
    }

    if (this.date) {
      this.selectedDate = new Date(this.date);
    }
    this.typeList = TYPE_LIST;
    this.statePublished = STATE_PUBLISHED;
    this.featuredOptions = FEATURED_OPTIONS;
    this.countriesList = COUNTRIES;
    this.notesList = NOTES_LIST;
    this.stateOptions = STATE_LIST;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
  }

  ngOnInit() {
    this.buildForm();

    this.getTechnology();
    this.getCategories();

    const id = this.route.snapshot.paramMap.get("id");

    if (id) {
      this.pageTitle = "Modifica Prodotto";
      this.loadingPage = true;

      this.startupsService.getId(+id).subscribe((res) => {
        this.loadingPage = false;
        this.element = res;
        this.imageInfos = this.slideshowService.getId(+id);
        this.checkUrl(this.element);

        this.usersService.getId(this.element.user_id).subscribe((res) => {
          this.user = res;
          this.cdr.detectChanges();
        });

        const paramsCategoriesFind = {
          startup_id: this.element.id,
        };

        this.blogForm.patchValue({
          startup_name: res.startup_name,
          startup_headline: res.startup_headline,
          page_url: res.page_url,
          startup_description: res.startup_description,
          startup_technology: (res.startup_technology || "").split(","), // Fix here
          startup_email: res.startup_email,
          startup_url: res.startup_url,
          country: res.country,
          is_featured: res.is_featured,
          backlink_url: res.backlink_url,
          markets: (res.markets || "").split(","),
          twitter: res.twitter,
          user_id: res.user_id,
          publish_date: res.publish_date,
          linkedin: res.linkedin,
          notes: res.notes,
          producthunt: res.producthunt,
          status: res.status,
          points: res.points ?? 5,
          id: res.id,
        });
        this.id = res.id;
        this.tourTitle = res.startup_name;
        this.startupStatus = res.status;
        this.imagePath = this.path + id + "/" + res.startup_logo;
        this.startupUrl = res.startup_url;
        this.userIdentification = res.user_id;
        this.populateSkills(res.skills || []);
        this.loadStartups();
        this.loadFounders(res.id);
        this.checkDomainRating();
        this.cdr.detectChanges();
      });
    } else {
      this.pageTitle = "Aggiungi Prodotto";
    }
  }

  private buildForm(): void {
    this.blogForm = this.fb.group({
      id: [""],
      startup_name: ["", Validators.required],
      startup_headline: ["", Validators.required],
      page_url: ["", Validators.required],
      startup_description: ["", Validators.required],
      startup_technology: [""],
      startup_email: [""],
      startup_url: [""],
      backlink_url: [""],
      markets: [""],
      country: [""],
      linkedin: [""],
      is_featured: [""],
      publish_date: ["", [dateValidator()]],
      notes: [""],
      twitter: [""],
      producthunt: [""],
      image: [""],
      user_id: [""],
      status: [""],
      points: [
        5,
        [
          Validators.required,
          Validators.min(1),
          Validators.max(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      skills: this.initSkill(),
    });
  }

  dayClick(event) {
    this.visibleDates = true;
  }

  get publishDate() {
    return this.blogForm.get("publish_date");
  }

  get f(): { [key: string]: AbstractControl } {
    return this.blogForm.controls;
  }

  goToUrl(): void {
    window.open(this.startupUrl, "_blank");
  }

  // Founders are linked to a startup through their `companies` JSON, where each
  // entry's `id` is the startup id. Fetch founders and keep those referencing it.
  loadFounders(startupId: number): void {
    this.foundersLoading = true;
    this.foundersService.list({ _start: 1, _limit: 300 }).subscribe({
      next: (data: any[]) => {
        const parse = (value: any) => {
          if (Array.isArray(value)) return value;
          if (!value) return [];
          try {
            return JSON.parse(value);
          } catch {
            return [];
          }
        };

        this.founders = (data || [])
          .map((founder) => {
            const company = parse(founder.companies).find(
              (c: any) => +c.id === +startupId,
            );
            return company
              ? { ...founder, role: company.role, year: company.year }
              : null;
          })
          .filter((f) => !!f);
        this.foundersLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.foundersLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  checkDomainRating(): void {
    const domain = this.startupsService.extractDomain(this.startupUrl);
    if (!domain) {
      this.domainRating = { loading: false, error: true };
      return;
    }
    this.domainRating = { loading: true };
    this.startupsService.checkDomainRating(domain).subscribe({
      next: (res) => {
        this.domainRating = {
          loading: false,
          rating: res?.data?.domain_rating,
          domain: res?.data?.domain,
          source: res?.data?.source,
        };
        this.cdr.detectChanges();
      },
      error: () => {
        this.domainRating = { loading: false, error: true };
        this.cdr.detectChanges();
      },
    });
  }

  /** Back to the list exactly as it was (page, filters), or to the list if there is no history. */
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(["/admin/startups"]);
    }
  }

  getDomainRankGaugeBackground(rating: number): string {
    const pct = Math.max(0, Math.min(100, rating));
    return (
      `conic-gradient(transparent 0 ${pct}%, #eee ${pct}% 100%),` +
      `conic-gradient(#ff3b30 0%, #ff9500 25%, #ffcc00 50%, #90ee90 75%, #34c759 100%)`
    );
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.blogForm.get("startup_logo").setValue(file);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.imagePath = reader.result;
      };
    }
  }

  checkUrl(element: Startups) {
    const checkUrl = {
      page_url: element.page_url,
      page: 0,
      limit: 2,
    };

    this.startupsService.list(checkUrl).subscribe((res: any[]) => {
      this.elementsUrl = res.filter((item) => item.id !== element.id);
      this.hasDuplicates = this.elementsUrl.length > 0;
      this.cdr.detectChanges();
    });
  }

  removeImageFile() {
    this.imagePath = "";
    this.myInputVariable.nativeElement.value = "";
  }

  public getCategories() {
    const paramsCategories = [];
    this.categoryService.list(paramsCategories).subscribe((pData) => {
      this.categoriesList = pData;
      this.cdr.detectChanges();
    });
  }

  public getTechnology() {
    const paramsTechnology = [];

    this.technologyService.list(paramsTechnology).subscribe((pData) => {
      this.technologyList = pData;
      this.cdr.detectChanges();
    });
  }

  unpublished() {
    const formData = new FormData();

    formData.append("status", "0");

    const id = this.blogForm.get("id").value;

    this.startupsService.update(formData, +id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.uploadError = res.message;
        } else {
          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Informazioni",
            detail: "Saved successfully",
          });
          //this.router.navigate(['/admin/products']);
          this.ngOnInit();
        }
      },
      (error) => (this.error = error),
    );
  }

  loadStartups(): void {
    const params = {
      user_id: this.element.user_id,
    };

    this.startupsService.list(params).subscribe((pData) => {
      this.startups = pData;
      this.count = this.startupsService.size;
      this.cdr.detectChanges();
    });
  }

  published() {
    const formData = new FormData();

    formData.append("status", "1");

    const id = this.blogForm.get("id").value;

    this.startupsService.update(formData, +id).subscribe(
      (res) => {
        if (res.status == "error") {
          this.uploadError = res.message;
        } else {
          this.requestResponse = {
            id_startup: this.element.id,
            id_user: this.user.id,
          };
          this.emailService.send(this.requestResponse).subscribe(
            (response) => {
              this.messageService.add({
                key: "myKey1",
                severity: "success",
                summary: "Informazioni",
                detail: "Email sent successfully!",
              });
            },
            (error) => {
              console.log("Error sending email", error);
            },
          );

          this.messageService.add({
            key: "myKey1",
            severity: "success",
            summary: "Informazioni",
            detail: "Saved successfully",
          });
          //this.router.navigate(['/admin/products']);
          this.ngOnInit();
        }
      },
      (error) => (this.error = error),
    );
  }

  sendNotes() {
    const formData = new FormData();

    const id = this.blogForm.get("id").value;
    const userId = this.blogForm.get("user_id").value;

    this.requestResponse = {
      id_startup: id,
      id_user: userId,
    };
    this.emailService.sendNotes(this.requestResponse).subscribe(
      (response) => {
        this.messageService.add({
          key: "myKey1",
          severity: "success",
          summary: "Informazioni",
          detail: "Email sent successfully!",
        });
      },
      (error) => {
        console.log("Error sending email", error);
      },
    );
  }

  initSkill() {
    return this.fb.array([]);
  }

  populateSkills(skills: any[]) {
    if (!Array.isArray(skills)) return;
    const formArray = this.blogForm.get("skills") as UntypedFormArray;
    formArray.clear();
    skills.forEach((e) => {
      formArray.push(
        this.fb.group({
          year: [e.year],
        }),
      );
    });
  }
  private createSkillFormGroup(skill: any): UntypedFormGroup {
    return new UntypedFormGroup({
      label: new UntypedFormControl(skill.label),
      value: new UntypedFormControl(skill.value),
    });
  }

  public addSkill(skill: any) {
    this.skills.push(this.createSkillFormGroup(skill));
  }

  get skills() {
    return this.blogForm.get("skills") as UntypedFormArray;
  }

  addQuantity() {
    this.skills.push(this.newQuantity());
  }

  removeQuantity(i: number) {
    this.skills.removeAt(i);
  }

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      label: "",
      value: "",
    });
  }

  getselectedCategories() {
    this.selectedCategories = this.category_id.split(",");
  }

  onSubmit() {
    if (this.isSaving) return;
    if (!this.blogForm.valid) {
      this.blogForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;

    const formData = new FormData();

    formData.append("startup_name", this.blogForm.get("startup_name").value);
    formData.append(
      "startup_description",
      this.blogForm.get("startup_description").value,
    );
    formData.append(
      "startup_technology",
      this.blogForm.get("startup_technology").value,
    );
    formData.append(
      "startup_headline",
      this.blogForm.get("startup_headline").value,
    );
    formData.append("page_url", this.blogForm.get("page_url").value);
    formData.append("startup_url", this.blogForm.get("startup_url").value);
    formData.append("startup_email", this.blogForm.get("startup_email").value);
    formData.append("linkedin", this.blogForm.get("linkedin").value);
    formData.append("country", this.blogForm.get("country").value);
    formData.append("twitter", this.blogForm.get("twitter").value);
    formData.append("status", this.blogForm.get("status").value);
    formData.append("points", this.blogForm.get("points").value);
    formData.append("backlink_url", this.blogForm.get("backlink_url").value);
    formData.append("notes", this.blogForm.get("notes").value);
    formData.append("publish_date", this.blogForm.get("publish_date").value);
    formData.append("producthunt", this.blogForm.get("producthunt").value);
    formData.append("is_featured", this.blogForm.get("is_featured").value);
    formData.append("markets", this.blogForm.get("markets").value);
    //formData.append("startup_logo", this.blogForm.get("startup_logo").value);
    formData.append("user_id", this.blogForm.get("user_id").value);

    const userId = this.blogForm.get("user_id").value;

    const id = this.blogForm.get("id").value;

    if (id) {
      this.startupsService.update(formData, +id).subscribe(
        (res) => {
          this.isSaving = false;
          if (res.status == "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Saved successfully",
            });
            //this.router.navigate(['/admin/products']);
          }
        },
        (error) => {
          this.isSaving = false;
          this.error = error;
        },
      );
    } else {
      this.startupsService.create(formData).subscribe(
        (res) => {
          this.isSaving = false;
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Informazioni",
              detail: "Saved successfully",
            });
            this.router.navigate(["/dashboard/startups"]);
          }
        },
        (error) => {
          this.isSaving = false;
          this.error = error;
        },
      );
    }
  }
}

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const datePattern = /^\d{4}-\d{2}-\d{2}$/; // Matches YYYY-MM-DD format
    const isValid = datePattern.test(control.value);

    return isValid ? null : { invalidDateTime: true }; // Error if format doesn't match
  };
}
